import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="17" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10.462 8.716A5.5 5.5 0 10.5 5.5a5.5 5.5 0 008.716 4.462L14.5 16l2-2-6.038-5.284zM6 9.5a4 4 0 110-8 4 4 0 010 8z" fill="#FCFCFC" /></svg>;